export const hasMultipleLanguages = (languages) => {
    if (languages) {
        return languages.length > 1;
    }

    return false;
};
